import React from "react";
import { useNavigate } from "react-router-dom";

export const NeetQp = ({ qp }) => {
  const navigate = useNavigate();
  const Phy_Qs_No = qp.phy.length;
  const Chem_Qs_No = qp.chem.length;
  const Bio_Qs_No = qp.bio.length;

  const x = 45,
    y = 90;

  const physics = () => {
    console.log(qp);
    const phyQs = [];
    for (let i = 0; i < 45; i++) {
      if (i < Phy_Qs_No) {
        phyQs.push(
          <button
            className="px-6 py-4 my-1 bg-lime-400 text-white font-bold w-fit mx-auto rounded-full"
            onClick={() =>
              navigate(`/create-question/${qp.phy[i].id}`, {
                state: { q: qp.phy[i], type: "phy", qp_id: qp.id },
              })
            }
          >
            {i + 1}
          </button>
        );
      } else {
        phyQs.push(
          <button
            className="px-6 py-4 my-1 bg-white text-black hover:bg-orange-500 hover:text-white font-bold w-fit mx-auto rounded-full"
            onClick={() => {
              navigate("/create-question", {
                state: { type: "phy", qp_id: qp.id },
              });
            }}
          >
            {i + 1}
          </button>
        );
      }
    }

    return phyQs;
  };

  const chemistry = () => {
    const chemQs = [];
    for (let i = 0; i < 45; i++) {
      if (i < Chem_Qs_No) {
        chemQs.push(
          <button
            className="px-6 py-4 my-1 bg-lime-400 text-white font-bold w-fit mx-auto rounded-full"
            onClick={() =>
              navigate(`/create-question/${qp.chem[i].id}`, {
                state: { q: qp.chem[i], type: "chem", qp_id: qp.id },
              })
            }
          >
            {i + 1}
          </button>
        );
      } else {
        chemQs.push(
          <button
            className="px-6 py-4 my-1 bg-white text-black hover:bg-orange-500 hover:text-white font-bold w-fit mx-auto rounded-full"
            onClick={() => {
              navigate("/create-question", {
                state: { type: "chem", qp_id: qp.id },
              });
            }}
          >
            {i + 1}
          </button>
        );
      }
    }
    return chemQs;
  };

  const biology = () => {
    const bioQs = [];
    for (let i = 0; i < 90; i++) {
      if (i < Bio_Qs_No) {
        bioQs.push(
          <button
            className="px-6 py-4 my-1 bg-lime-400 text-white font-bold w-fit mx-auto rounded-full"
            onClick={() =>
              navigate(`/create-question/${qp.bio[i].id}`, {
                state: { q: qp.bio[i], type: "bio", qp_id: qp.id },
              })
            }
          >
            {i + 1}
          </button>
        );
      } else {
        bioQs.push(
          <button
            className="px-6 py-4 my-1 bg-white text-black hover:bg-orange-500 hover:text-white font-bold w-fit mx-auto rounded-full"
            onClick={() => {
              navigate("/create-question", {
                state: { type: "bio", qp_id: qp.id },
              });
            }}
          >
            {i + 1}
          </button>
        );
      }
    }
    return bioQs;
  };

  return (
    <>
      <div className="flex flex-col">
        <button
          onClick={() => navigate("/view-full-paper", { state: { qp: qp } })}
          className="text-xl my-4 bg-[#3F72AF]  mx-auto rounded-lg p-2 text-white font-semibold"
        >
          View Full Paper
        </button>
        <>
          <p className="text-3xl font-semibold py-4">Physics</p>
          <div className="grid grid-cols-6">{physics()}</div>
          <p className="text-3xl font-semibold py-4">Chemistry</p>
          <div className="grid grid-cols-6">{chemistry()}</div>
          <p className="text-3xl font-semibold py-4">Biology</p>
          <div className="grid grid-cols-6">{biology()}</div>
        </>
      </div>
    </>
  );
};
